import { create } from 'zustand'
import { authApi } from '@/api/endpoints'
import type { User } from '@/api/types'

interface AuthState {
  user: User | null
  loading: boolean
  loaded: boolean
  load: () => Promise<void>
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  loaded: false,
  load: async () => {
    set({ loading: true })
    try {
      const user = await authApi.me()
      set({ user, loaded: true })
    } catch {
      set({ user: null, loaded: true })
    } finally {
      set({ loading: false })
    }
  },
  login: async (email, password) => {
    await authApi.login(email, password)
    const user = await authApi.me()
    set({ user, loaded: true })
  },
  logout: async () => {
    try {
      await authApi.logout()
    } finally {
      set({ user: null })
    }
  },
}))
